import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Contacto from './components/contacto/Contacto';
import ContactoContacto from './components/contacto/ContactoContacto';
import ContactoDomicilio from './components/contacto/ContactoDomicilio';
import ContactoObservaciones from './components/contacto/ContactoObservaciones';

import Concesion from './components/concesion/Concesiones';
import Herramientas from './components/Herramientas';
import Historial from './components/historial/Historial';
import OrdenPago from './components/ordenpago/OrdenPago';
import Reporte from './components/reportes/Reporte';
import UsuarioLogin from './components/usuario/UsuarioLogin';

import agregarFechaPospuesta from './helpers/datos/agregarFechaPospuesta';
import obtenerCatalogos from './helpers/catalogos/listas/obtenerCatalogos';

import TablaIngresosMensual from './components/tablas/TablaIngresosMensual';
import TablaIngresosTemporada from './components/tablas/TablaIngresosTemporada';

import reporteGeneral from './helpers/reportes/reporteGeneral';
/* import { chartPolizaPie } from './helpers/poliza/chartPolizaPie';
import chartIngresosMensuales from './helpers/poliza/chartIngresosMensuales'; */


const App = () => {

  const [data, setData] = useState({});
  const [catalogos, setCatalogos] = useState({});
  const [dataLoadded, setDataLoaded] = useState(false);
  const [nuevosTramites, setNuevosTramites] = useState([]);
  const [aPagar, setAPagar] = useState(0);
  const [observaciones, setObservaciones] = useState("");
  const [anualidad, setAnualidad] = useState(null);
  const [vigencia, setVigencia] = useState(agregarFechaPospuesta(15));
  const [folio, setFolio] = useState("");

  /* const today = new Date();
  const yyyy = today.getFullYear() - 1;
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = "0" + mm;
  let fechaPrimaveraPrevia = `${yyyy}-${mm}-${dd}`;
  let fechaPrimaveraActual = `${yyyy + 1}-${mm}-${dd}`; */
  const today = new Date();
  const yyyy = today.getFullYear();
  var mm = today.getMonth() + 1;
  var dd = today.getDate();

  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = "0" + mm;
  var fechaPrimaveraPrevia = `${Number(mm - 1) === 0 ? yyyy - 1 : yyyy}-${Number(mm - 1) === 0 ? 12 : mm - 1 < 10 ? "0" + (mm - 1) : mm - 1}-${Number(dd) <= 28 ? dd : "01"}`;
  var fechaPrimaveraActual = `${yyyy}-${mm}-${dd}`;

  const [primavera1, setPrimavera1] = useState(String(Number(fechaPrimaveraPrevia.split("-")[0])));
  const [primavera2, setPrimavera2] = useState(String(Number(fechaPrimaveraActual.split("-")[0])));
  const [primavera1Values, setPrimavera1Values] = useState([]);
  const [primavera2Values, setPrimavera2Values] = useState([]);
  /* const [valoresTemporada, setValoresTemporada] = useState([0, 0, 0, 0, 0]); */
  const [valoresReporteGeneral, setValoresReporteGeneral] = useState([]);
  const [estatusPoliza, setEstatusPoliza] = useState(0);
  const [idTramite, setIdTramite] = useState(0);
  const [idConceptoPago, setIdConceptoPago] = useState(0);
  const [idUsuario, setIdUsuario] = useState(0);
  const [checked, setChecked] = useState(true);

  const [fecha1, setFecha1] = useState(fechaPrimaveraPrevia);
  const [fecha2, setFecha2] = useState(fechaPrimaveraActual);
  const [dia1, setDia1] = useState(String(Number(fechaPrimaveraPrevia.split("-")[2])));
  const [dia2, setDia2] = useState(String(Number(fechaPrimaveraActual.split("-")[2])));
  const [mes1, setMes1] = useState(String(Number(fechaPrimaveraPrevia.split("-")[1])));
  const [mes2, setMes2] = useState(String(Number(fechaPrimaveraActual.split("-")[1])));
  const [listaEstatus, setListaEstatus] = useState([]);
  const [listaUsuarios, setListaUsuarios] = useState([]);
  /* const [finalValues, setFinalValues] = useState([]); */

  useEffect(() => {
    obtenerCatalogos(catalogos, setCatalogos, setDataLoaded);
    reporteGeneral(primavera1, primavera2, dia1, dia2, mes1, mes2, idConceptoPago, listaEstatus, listaUsuarios, setValoresReporteGeneral);
    /* chartPolizaPie(primavera1, primavera2, dia1, dia2, mes1, mes2, idConceptoPago, listaUsuarios, setValoresTemporada); */
    /* chartIngresosMensuales(primavera1, primavera2, idConceptoPago, listaEstatus, listaUsuarios, setFinalValues); */
  }, [data, primavera1, primavera2, estatusPoliza, idTramite, idConceptoPago, fecha1, fecha2, dia1, dia2, mes1, mes2, idUsuario,
    listaEstatus, listaUsuarios, checked]);

  return (
    <>
      <Herramientas setData={setData} data={data}
        nuevosTramites={nuevosTramites}
        aPagar={aPagar}
        vigencia={vigencia}
        observaciones={observaciones} setObservaciones={setObservaciones}
        anualidad={anualidad} setAnualidad={setAnualidad}
        setFolio={setFolio} setNuevosTramites={setNuevosTramites}
        setListaEstatus={setListaEstatus} setListaUsuarios={setListaUsuarios}
        setIdTramite={setIdTramite} setIdConceptoPago={setIdConceptoPago}

        primavera1={primavera1}
        primavera2={primavera2}
        valoresReporteGeneral={valoresReporteGeneral}
        listaEstatus={listaEstatus}
        listaUsuarios={listaUsuarios}
        catalogos={catalogos}
      />

      <Routes>
        <Route path="contacto" element={<Contacto catalogos={catalogos} dataLoaded={dataLoadded} data={data} setData={setData} />} >
          <Route path="contacto" element={<ContactoContacto data={data} setData={setData} />} />
          <Route path="domicilio" element={<ContactoDomicilio catalogos={catalogos} dataLoaded={dataLoadded} data={data} setData={setData} />} />
          <Route path="observaciones" element={<ContactoObservaciones data={data} setData={setData} />} />
        </Route>
        <Route path="concesion" element={<Concesion data={data} setData={setData} catalogos={catalogos} checked={checked} setChecked={setChecked} />} />
        <Route path="ordenpago" element={
          <OrdenPago catalogos={catalogos} dataLoaded={dataLoadded} data={data} setData={setData}
            nuevosTramites={nuevosTramites} setNuevosTramites={setNuevosTramites}
            setAPagar={setAPagar} vigencia={vigencia} setVigencia={setVigencia}
            observaciones={observaciones} setObservaciones={setObservaciones}
            anualidad={anualidad} setAnualidad={setAnualidad}
          />}
        />
        <Route path="historial" element={<Historial data={data} setData={setData} catalogos={catalogos} folio={folio} setFolio={setFolio} />} />

        <Route path="reportes" element={<Reporte data={data} setData={setData} dataLoaded={dataLoadded} catalogos={catalogos}
          primavera1={primavera1}
          setPrimavera1={setPrimavera1}
          primavera2={primavera2}
          setPrimavera2={setPrimavera2}
          primavera1Values={primavera1Values}
          setPrimavera1Values={setPrimavera1Values}
          primavera2Values={primavera2Values}
          setPrimavera2Values={setPrimavera2Values}
          estatusPoliza={estatusPoliza}
          setEstatusPoliza={setEstatusPoliza}
          fecha1={fecha1}
          setFecha1={setFecha1}
          fecha2={fecha2}
          setFecha2={setFecha2}
          idTramite={idTramite}
          setIdTramite={setIdTramite}
          idConceptoPago={idConceptoPago}
          setIdConceptoPago={setIdConceptoPago}
          idUsuario={idUsuario}
          setIdUsuario={setIdUsuario}
          dia1={dia1}
          setDia1={setDia1}
          dia2={dia2}
          setDia2={setDia2}
          mes1={mes1}
          setMes1={setMes1}
          mes2={mes2}
          setMes2={setMes2}
          listaEstatus={listaEstatus}
          setListaEstatus={setListaEstatus}
          listaUsuarios={listaUsuarios}
          setListaUsuarios={setListaUsuarios}
        />} >
          <Route path="poranualidad" element={<TablaIngresosMensual
            primavera1={primavera1}
            primavera2={primavera2}
            /* finalValues={finalValues} */
          />} />
          <Route path="estatusglobal" element={<TablaIngresosTemporada
            catalogos={catalogos}
            fecha1={fecha1}
            fecha2={fecha2}
            /* values={valoresTemporada} */
          />} />
        </Route>
        <Route path="login" element={<UsuarioLogin />} />
        <Route path="*" element={<Navigate to="login" />} />
      </Routes>
    </>
  );
}

export default App;
